import React from "react";

/**
 * Circular "stamp" badge — fixed bottom-left.
 * Curved text top + bottom around a center mark.
 */
export default function KvinneBadge({ topText, bottomText }) {
  return (
    <div
      data-testid="kvinne-badge"
      className="hidden md:flex fixed bottom-6 left-6 z-40 select-none"
      aria-label="Kvinne for kvinne — trygt valg"
    >
      <div className="relative w-[112px] h-[112px] rounded-full bg-[#0F2C29] text-[#F8F9FA] shadow-[0_8px_30px_rgba(15,44,41,0.35)] ring-1 ring-white/10">
        <svg
          viewBox="0 0 200 200"
          className="absolute inset-0 w-full h-full animate-[spin_22s_linear_infinite]"
        >
          <defs>
            <path
              id="kb-top"
              d="M 100,100 m -76,0 a 76,76 0 1,1 152,0"
            />
            <path
              id="kb-bottom"
              d="M 100,100 m -72,0 a 72,72 0 1,0 144,0"
            />
          </defs>
          <text
            fill="currentColor"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "16px",
              letterSpacing: "5px",
            }}
          >
            <textPath href="#kb-top" startOffset="50%" textAnchor="middle">
              {topText}
            </textPath>
          </text>
          <text
            fill="currentColor"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "12px",
              letterSpacing: "5px",
            }}
          >
            <textPath href="#kb-bottom" startOffset="50%" textAnchor="middle">
              {"• " + bottomText + " •"}
            </textPath>
          </text>
        </svg>
        {/* Center mark */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className="font-serif italic text-[22px] leading-none"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            K<span className="text-[12px] align-super">f</span>K
          </div>
        </div>
        {/* dotted inner ring */}
        <div className="absolute inset-2 rounded-full border border-dashed border-white/25 pointer-events-none" />
      </div>
    </div>
  );
}
